import { fetchDataFromURL } from '../api/fetchDataFromURL';
import ActionTypes from './types';

/** @param {import('../typings').HomePageState} props */
export const fetchOptionSummaryAction = (props) => async (dispatch) => {
  try {
    const { currentDate } = props;

    await dispatch({
      type: ActionTypes.SET_APP_STATE,
      payload: {
        ThirdLoading: true,
      },
    });

    const data = await fetchDataFromURL(
      `/api/get-thirdhometable-data?date=${currentDate}`
    );
    if (data && data.length) {
      dispatch({
        type: ActionTypes.SET_APP_STATE,
        payload: {
          weekendErrorsBox3: null,
          homeThirdTable: data,
          ThirdLoading: false,
        },
      });
    } else {
      dispatch({
        type: ActionTypes.SET_APP_STATE,
        payload: {
          weekendErrorsBox3: " Can't Get Data Might be Weekend or Holiday",
          homeThirdTable: [],
          ThirdLoading: false,
        },
      });
    }
  } catch (error) {
    dispatch({
      type: ActionTypes.SET_APP_STATE,
      payload: {
        weekendErrorsBox3: " Can't Get Data Might be Weekend or Holiday",
        homeThirdTable: [],
        ThirdLoading: false,
      },
    });
  }
};



// WEBPACK FOOTER //
// ./src/actions/fetchOptionSummaryAction.js